import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import Amplify from 'aws-amplify';
import * as React from 'react';
import { Route, Switch } from 'react-router';
import FairProcessingNotice from './components/FairProcessingNotice';
import Footer from './components/Footer';
import Header from './components/Header';
import LoggedOut from './components/LoggedOut';
import ReloadModal from './components/ReloadModal';
import Administrator from './scenes/administrator';
import ViewApplication from './scenes/candidate';
import HiringManager from './scenes/hiring-manager';
import Vacancy from './scenes/vacancy';

Amplify.configure({
    Auth: {
        identityPoolId: 'eu-central-1:11d20f71-4e9f-4623-8be4-e19b2b1fd6c2',
        region: 'eu-central-1',
        userPoolId: 'eu-central-1_Fu3LKUhlN',
        userPoolWebClientId: 'un957ljl24djmtibgurt6vfhm'
    }
});

Sentry.init({
    dsn: 'https://f74fec4d83394308a49f0fc4e947d982@o419688.ingest.sentry.io/5831616',
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
});
class App extends React.Component {
    constructor(props: any) {
        super(props);
    }

    public render() {
        return (
            <div className="App">
                <Header />
                <ReloadModal />
                <Switch>
                    <Route exact={false} path="/candidate/:applicationId" component={ViewApplication} />
                    <Route exact={true} path="/hiring-manager/:vacancyId" component={HiringManager} />
                    <Route exact={true} path="/vacancy/:vacancyId" component={Vacancy} />
                    <Route exact={true} path="/administrator" component={Administrator} />
                    <Route exact={true} path="/logout" component={LoggedOut} />
                    <Route exact={true} path="/fair-processing-notice" component={FairProcessingNotice} />
                </Switch>

                <Footer />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx